module.exports = __webpack_public_path__ + "img/insurance-company-3.png";